import { render, staticRenderFns } from "./TestimCard3.vue?vue&type=template&id=020b3e98&scoped=true&"
import script from "./TestimCard3.vue?vue&type=script&lang=js&"
export * from "./TestimCard3.vue?vue&type=script&lang=js&"
import style0 from "./TestimCard3.vue?vue&type=style&index=0&id=020b3e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b3e98",
  null
  
)

export default component.exports